export default {
  // 对话框标题
  dialogTitle: "共同交易对手",

  // 选项标题
  commonInflowAbsolute: "共同流入（绝对）",
  commonInflowRelative: "共同流入（相对）",
  commonOutflowAbsolute: "共同流出（绝对）",
  commonOutflowRelative: "共同流出（相对）",

  // 选项说明
  commonInflowAbsoluteInfo: "所选节点有绝对的共同流入交易对手",
  commonInflowRelativeInfo: "所选节点有部分的共同流入交易对手",
  commonOutflowAbsoluteInfo: "所选节点有绝对的共同流出交易对手",
  commonOutflowRelativeInfo: "所选节点有部分的共同流出交易对手",
};
